module.exports = __webpack_public_path__ + "img/main_mobile-old.bfe63a07.jpg";